import {Dropdown} from 'primereact/dropdown';
import React, {useEffect, useMemo, useState} from "react";
import {useGetProductTemplateForeignKeys} from "api/api-hooks/product-templates-hooks";
import { T } from 'services/lang/LanguageService';
import { IForeignKey, IOptions } from './ForeignKeyTypes';

export default function ForeignKey(props: IForeignKey) {
    const {
        data,
        isError,
        isLoading
    } = useGetProductTemplateForeignKeys(props.foreignTemplateKey, {staleTime: 0,enabled:props.editable});

    const [options, setOptions] = useState<Array<IOptions>>([])

    const sortedOptions = useMemo(() => {
        if (data) {
            const tempOptions = [...data].map((ob: any) => {
                return {label: ob.represantationString, value: ob}
            })
            tempOptions.sort((a, b) => {
                if (a.label < b.label) {
                    return -1;
                }
                if (a.label > b.label) {
                    return 1;
                }
                return 0;
            });
            return [{label: 'Unselected', value: null}, ...tempOptions];
        }
        return [];
    }, [data]);

    useEffect(() => {
        setOptions(sortedOptions);
    }, [sortedOptions]);

    const valueChangeHandler = (e: any) => {
        props.changeHandler(e.value);
    }

    const displayValue = props.value?.represantationString ?? 'Not Selected';

    if (props.editable) {
        return <>
            {isLoading &&
                <>{T("word.loading")}</>
            }

            {isError &&
                <>{T("alert.error")}</>
            }

            {!isLoading && !isError &&
                <Dropdown style={{width: '100%', textAlign: 'left'}}
                          value={displayValue}
                          options={options}
                          placeholder={displayValue}
                          onChange={(e) => valueChangeHandler(e)}
                          required
                          dataKey='1'
                          filter
                />
            }
        </>
    } 
        return <>
            {
                props?.value?.represantationString ? (
                    <div className="p-inputtext" style={{border: '0px transparent', backgroundColor: 'transparent', whiteSpace: props.foreignKeyWrap ? "pre-wrap" : "nowrap"}}>
                        {displayValue}
                    </div>
                ) : (
                    "-"
                )
            }
        </>
    
}